/**
 * Main Layout Component for non-scheduler pages
 */

import React from 'react'
import HeaderSinglePage from './HeaderSinglePage'
import Footer from './Footer'

export default function MainLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-100 focus:rounded-md focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-primary-darkGreen focus:shadow-lg focus:outline focus:outline-2 focus:outline-primary-darkGreen"
      >
        Skip to content
      </a>
      <HeaderSinglePage />
      <main id="main-content" className="flex-grow" tabIndex={-1}>
        {children}
      </main>
      <Footer />
    </div>
  )
}
